const SET_CAMPAIGN_PREVIEW = '/hubCampaigns/SET_CAMPAIGN_PREVIEW';
const GET_CAMPAIGN_PREVIEW = '/hubCampaigns/GET_CAMPAIGN_PREVIEW';
const SET_CAMPAIGN_LIST = '/hubCampaigns/SET_CAMPAIGN_LIST';
const SET_PICKED_CAMPAIGN = '/hubCampaigns/SET_PICKED_CAMPAIGN';
const SET_SOCIAL_DATA_PAGINATION = '/hubCampaigns/SET_SOCIAL_DATA_PAGINATION';
const SET_SALES_DATA_PAGINATION = '/hubCampaigns/SET_SALES_DATA_PAGINATION';

export default {
    SET_CAMPAIGN_PREVIEW,
    GET_CAMPAIGN_PREVIEW,
    SET_CAMPAIGN_LIST,
    SET_PICKED_CAMPAIGN,
    SET_SOCIAL_DATA_PAGINATION,
    SET_SALES_DATA_PAGINATION,
};
